const formatChecksum = (checksum: string) => {
    return checksum.toUpperCase()
        .replace(/"/g, '')
        .replace(/(.{4})/g, '$1 ').trim();
}

const shortChecksum = (checksum: string) => {
    return checksum.substring(0, 7)
}

export const useChecksum = () => {
    return {
        formatChecksum,
        shortChecksum
    }
}
